import {ContentUpvotesAPI} from 'api/content_upvotes';
import {QuestionsAPI} from 'api/questions';
import {TrackingAPI} from 'api/tracking';
import {Button} from 'components/system/button';
import {Latex} from 'components/system/latex';
import {Spinner} from 'components/system/spinner';
import {useTabs} from 'components/system/tabs';
import {TextContainer} from 'components/system/text_container';
import {Vote} from 'components/system/vote';
import {useEffect, useState} from 'react';
import {Upsell, useAuth} from 'users';
import styles from './solution.module.css';

export const Solution = ({question}: Props) => {
  const {user, hasPermission} = useAuth();
  const {setTab} = useTabs();
  const [solution, setSolution] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getAnswer = async () => {
      setLoading(true);
      const solution = await QuestionsAPI.getAnswer(question.slug);
      setSolution(solution);
      setLoading(false);
    };
    if (question.has_solution && hasPermission('question_solution_view', question.slug)) {
      getAnswer();
    }
    TrackingAPI.solutionViewed(question);
  }, [question.slug]);

  if (loading) return <Spinner size='sm' text='Loading solution' />;

  return (
    <div className={styles.container}>
      {solution !== '' && (
        <TextContainer>
          <Latex>{solution}</Latex>
        </TextContainer>
      )}
      {!question.has_solution && (
        <>
          <p>
            We don't have an official solution yet. In the meantime, you can check out the user
            submissions and the comments. Or submit your own solution for discussion!
          </p>
          <div className={styles.buttons}>
            {question.languages.length > 0 && (
              <Button color='orangeLight' onClick={() => setTab('User submissions')}>
                View user submissions
              </Button>
            )}
            <Button color='orangeLight' href='#comment-list'>
              View comments
            </Button>
          </div>
        </>
      )}
      <Upsell
        cta='question.viewSolution'
        sourceObject={question}
        barrier={question.has_solution && solution === ''}
      />
      {solution !== '' && (
        <div className={styles.vote}>
          {user.loggedIn && (
            <>
              <div>Was this solution useful?</div>
              <Vote
                upvotes={question.solution_upvotes}
                userVote={question.solution_vote}
                onVote={(vote) => ContentUpvotesAPI.upvoteSolution(question.slug, vote)}
                hideVote={!user.isAdmin}
              />
            </>
          )}
        </div>
      )}
    </div>
  );
};

type Props = {
  question: Question;
};
